/**
 * Button Grouping Form Field Component
 * @module patterns/components/form-and-content/fields/button-grouping
 */

import { type App } from '~/app';

export default (app: App) => {
    app.logger.debug('[Stockland FE] Initialise Multi Stockland Button Grouping Field Component');

    const listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]> = [];

    app.afterMount
        .then(() => {
            mountMultiButtonGroupingFormField(listeners);
        })
        .catch((error) => {
            throw new Error('[Stockland FE] Unable to register Stockland Multi Button Grouping Field Component', error);
        });

    return function destroyButtonGroupingFormField() {
        unMountMultiButtonGroupingFormField(listeners);

        app.logger.debug('[DXA] Multi Button Grouping Field Component destroyed');
    };
};

export function mountMultiButtonGroupingFormField(
    listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]>,
    root: HTMLElement | null = null
) {
    let rootNode: Document | HTMLElement = document;
    if (root) rootNode = root;
    const forms = rootNode.querySelectorAll<HTMLElement>('form');

    for (const form of forms) {
        const buttonGroupings = form.querySelectorAll<HTMLElement>('.multi-button-grouping-field');

        // HiddenSelect is what Optimizely Forms will use for validation/submit value(s)
        const hiddenSelect = form.querySelector<HTMLSelectElement>('.multi-button-grouping-hidden-element');
        for (const buttonGrouping of buttonGroupings) {
            const buttons = buttonGrouping.querySelectorAll<HTMLSelectElement>('button');
            for (const button of buttons) {
                const handleButtonClick = (event: Event) => {
                    event.preventDefault();

                    // Clear out selected styling
                    for (const button of buttons) {
                        button.classList.remove('selected');
                    }

                    if (event && hiddenSelect) {
                        const targetElement = event.currentTarget as HTMLElement;
                        let buttonValue = '';
                        let selectedValues = '';
                        
                        if(targetElement)
                        {
                            buttonValue = targetElement.dataset.value || "";
                        }

                        // Check if any items are already selected
                        for (const hiddenOption of hiddenSelect.options) {
                            if (selectedValues.length > 0) selectedValues += '|';
                            selectedValues += hiddenOption.selected ? hiddenOption.value : '';
                        }

                        let valueArray = selectedValues ? selectedValues.split('|') : [];

                        if (valueArray.includes(buttonValue)) {
                            // Option deselected
                            valueArray = valueArray.filter((x) => x !== buttonValue);
                            button.classList.remove('selected');
                        } else {
                            // Option select
                            valueArray = [buttonValue];
                            button.classList.add('selected');
                        }

                        // Set the hidden select field so Optimizely forms is able to validate and submit the values
                        for (const hiddenOption of hiddenSelect.options) {
                            hiddenOption.selected = valueArray.some((x) => x.toLowerCase() == hiddenOption.value.toLowerCase());
                        }

                        // Strip empty items of any falsy values (false, 0, 0, 0n, "", null, undefined, NaN)
                        valueArray = valueArray.filter(Boolean);
                    }


                };

                button.addEventListener('click', handleButtonClick);
                listeners.push([button, 'click', handleButtonClick]);
            }
        }
    }
}

export function unMountMultiButtonGroupingFormField(
    listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]>
) {
    for (const [element, event, listener] of listeners) {
        element.removeEventListener(event, listener);
    }
}

export function selectDefaultInButtonGroup(currentButtonGroup:HTMLElement,selectElementText:string){
    const buttonGroupingContainer = currentButtonGroup?.parentNode;
    if(buttonGroupingContainer){
        const interestedButtonElement = buttonGroupingContainer.querySelector<HTMLElement>(`[data-option-text="${selectElementText}"]`);
        if(interestedButtonElement)
        {
            interestedButtonElement.click();
            interestedButtonElement.classList.add('selected');
        }
    }
}
